exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".njHczxllCwz-URDdWQ7S7,._2SE-spuckGXUCe95P1dwhU{font-size:12px}._2SE-spuckGXUCe95P1dwhU{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] .cw7FNDW9odg5bVhBxh6Nr{padding-top:1px;padding-bottom:1px}html[dir=ltr] .cw7FNDW9odg5bVhBxh6Nr{padding-left:15px}html[dir=rtl] .cw7FNDW9odg5bVhBxh6Nr{padding-right:15px}._1CRDUFyd0BnfDF_DPBdbOo{width:24px;height:24px;line-height:32px}", ""]);
// Exports
exports.locals = {
	"roomPersonaPrimaryText": "njHczxllCwz-URDdWQ7S7",
	"roomPersonaSecondaryText": "_2SE-spuckGXUCe95P1dwhU",
	"roomPersona": "cw7FNDW9odg5bVhBxh6Nr",
	"roomIcon": "_1CRDUFyd0BnfDF_DPBdbOo"
};